var _circle, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartbasedLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#064AD3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50009 10.9977C7.37184 10.9977 7.24435 10.9489 7.14685 10.8514C6.95185 10.6564 6.95185 10.3399 7.14685 10.1442L10.5998 6.69117C10.7948 6.49617 11.1113 6.49617 11.3071 6.69117C11.5021 6.88617 11.5021 7.20267 11.3071 7.39842L7.85409 10.8514C7.75585 10.9489 7.62834 10.9977 7.50009 10.9977Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6245 8.49975C11.527 8.49975 11.431 8.4615 11.359 8.39025L9.60923 6.6405C9.50198 6.53325 9.46973 6.372 9.52823 6.23175C9.58598 6.0915 9.72323 6 9.87473 6H11.6245C11.8315 6 11.9995 6.168 11.9995 6.375V8.12475C11.9995 8.27625 11.908 8.41275 11.7677 8.47125C11.722 8.49 11.6725 8.49975 11.6245 8.49975Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5016 13.1296V16.0044H6.5016V13.1296C6.5016 12.7846 6.78135 12.5049 7.12635 12.5049H8.8761C9.2211 12.5049 9.5016 12.7846 9.5016 13.1296Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 11.1306V16.0056H10.5015V11.1306C10.5015 10.7856 10.7813 10.5059 11.1263 10.5059H12.876C13.2218 10.5051 13.5015 10.7856 13.5015 11.1306Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5028 9.12963V16.0049H14.5028V9.12963C14.5028 8.78463 14.7826 8.50488 15.1276 8.50488H16.878C17.223 8.50488 17.5028 8.78463 17.5028 9.12963Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 17.4961H6.375C6.168 17.4961 6 17.3281 6 17.1211C6 16.9141 6.168 16.7461 6.375 16.7461H17.625C17.832 16.7461 18 16.9141 18 17.1211C18 17.3281 17.832 17.4961 17.625 17.4961Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartbasedLogo);
export default __webpack_public_path__ + "static/media/ChartbasedLogo.57ea6662f3d2d8f86e329d3ed2709560.svg";
export { ForwardRef as ReactComponent };